export default "__VITE_ASSET__CBIrUyWO__"